import { Flex, IconWarningSolid } from '@smarterservices/smarter-ui';
import { useEffect } from 'react';
import DualPane from '../DualPane';
import StepInstructions from '../Common/StepInstructions';
import { usePaneViewer } from '../PaneViewer';
import { checkValidMachineSetup } from '../../helpers/helpers';

const UnsupportedDevice = ({ stepData }) => {

   const { onNext, setIsTaskComplete } = usePaneViewer();

   useEffect(() => {
      // run the device check to confirm that indeed it is unsupported, it is possible they have switched devices for this same session...
      const checkMachineSetup = checkValidMachineSetup(window);
      if (checkMachineSetup.valid === true) {
        setIsTaskComplete(true);
        onNext();
      }
    }, []);

  return (
    <>
      {stepData && (
        <DualPane
          leftPane={
            <StepInstructions instructions={stepData?.body} />
          }
          rightPane={
            <Flex direction="column" alignItems="center">
              <IconWarningSolid size="x-large" color="warning" />
            </Flex>
          }
        />
      )}
    </>
  );
};

export default UnsupportedDevice;
